export default __webpack_public_path__ + "static/cover-anim-da9d0cb765aec019ee39dd6b68981c07.gif";